import { useEffect, useRef, useState } from 'react';
import './App.css';
import './Responsive.css';
import { createContext } from 'react';
import Home from './components/Home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import HomeOwnerConceirge from './components/homeowner-conceirge/HomeOwnerConceirge';
import AuthPage from './components/homeowner-conceirge/AuthPage';
import LandingPage from './components/homeowner-conceirge/LandingPage';
import PropertyOwner from './components/PropertyOwner';
import HomeownerLanding from './components/HomeownerLanding';

export const context = createContext();

const authTokens = localStorage.getItem('authTokens');
const tokens = JSON.parse(authTokens);
const isAuthenticated = tokens?.access

function App() {
  const token = "Token d62ce1b03b6952eaea3ed5aa9737b28b5ff4abdd";
  const app = useRef();
  const right_container = useRef();
  const [slideCount, setSlideCount] = useState();
  const [urlToRedirect, setUrlToRedirect] = useState({});
  const [submittedContactId, setSubmittedContactId] = useState("")
  const [categories, setCategories] = useState();
  const [professions, setProfessions] = useState([]);
  const [passwordEye, setPasswordEye] = useState(false);
  const [confirmPasswordEye, setConfirmPasswordEye] = useState(false);
  const [states, setStates] = useState();
  const [countys, setCountys] = useState();
  let readyToSubmit = false;
  const [submitClicked, setSubmitClicked] = useState(false);
  const [showAgreement, setShowAgreement] = useState(true);
  const [agreeEnabled, setAgreeEnabled] = useState(false);
  const [referred, setreferred] = useState(false);
  const [referredImg, setReferredImg] = useState("");
  const [redeemId, setRedeemId] = useState();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isPlayClicked, setIsPlayClicked] = useState(false);
  // const { invitation } = useParams();
  const [searchParams] = useSearchParams()
  const stepIndex = searchParams.get('stepIndex');
  const userId = searchParams.get('userId');
  const contactId = searchParams.get('contactId');

  const [payload, setPayload] = useState({
    first_name: { "first_name": "", "warning": false },
    last_name: { "last_name": "", "warning": false },
    phone: { "phone": "", "warning": false, "text": "Please fill this in" },
    email: { "email": "", "warning": false, "text": "Enter a valid email" },
    company: { "company": "", "warning": false },
    tac: { "tac": false, "warning": false },
    checkoutTac: { "checkoutTac": false, "warning": false },
    // category: {"category": "none", "warning": false},
    profession: { "profession": "none", "warning": false },
    are_you_forming_a_new_concierge_community: { "are_you_forming_a_new_concierge_community": "", "warning": false },
    clients_twelve_months: { "clients_twelve_months": "", "warning": false },
    clients_warm_market: { "clients_warm_market": "", "warning": false },
    from_which_profession_receive_most_referrals: { "from_which_profession_receive_most_referrals": "", "warning": false },
    to_which_profession_send_most_referrals: { "to_which_profession_send_most_referrals": "", "warning": false },
    website_url: { "website_url": "", "warning": false },
    instagram_handle: { "instagram_handle": "", "warning": false },
    facebook_link: { "facebook_link": "", "warning": false },
    linkedin_handle: { "linkedin_handle": "", "warning": false },
    tiktok_handle: { "tiktok_handle": "", "warning": false },
    youtube_link: { "youtube_link": "", "warning": false },
    about_yourself: { "about_yourself": "", "warning": false },
    state: { "state": "none", "warning": false },
    county: { "county": "none", "warning": false },
    city: { "city": "", "warning": false },
    zip: { "zip": "", "warning": false },
    preferred_mailing_address: {"preferred_mailing_address": "", "warning": false},
    preferred_mailing_state: {"preferred_mailing_state": "none", "warning": false},
    preferred_mailing_city: {"preferred_mailing_city": "", "warning": false},
    preferred_mailing_zip: {"preferred_mailing_zip": "", "warning": false},
    do_you_consider_real_estate_part_of_your_retirement_strategy: { "do_you_consider_real_estate_part_of_your_retirement_strategy": "", "warning": false },
    // will_you_be_using_the_app_for: {"will_you_be_using_the_app_for": "", "warning": false},
    choose_primary_goal: {
      "choose_primary_goal": [
        "Tax savings",
        "Ease of investment",
        "Cash flow",
        "Capital appreciation",
        "Legacy planning",
        "Home maintenance",
      ], "warning": false
    },
    whats_your_goal_for_capital_appreciation: { "whats_your_goal_for_capital_appreciation": "", "warning": false },
    when_do_you_want_to_achieve_this_capital_appreciation_goal: { "when_do_you_want_to_achieve_this_capital_appreciation_goal": "", "warning": false },
    whats_your_goal_for_cash_flow: { "whats_your_goal_for_cash_flow": "", "warning": false },
    when_do_you_want_to_achieve_this_cash_flow_goal: { "when_do_you_want_to_achieve_this_cash_flow_goal": "", "warning": false },
    // future_growth: {"future_growth": "none", "warning": false},
    introduced_by_name: { "introduced_by_name": "" },
    introduced_by_email: { "introduced_by_email": "", "warning": false, "text": "Enter a valid email" },
    password: { "password": "", "warning": false, "type": "password" },
    confirm_password: { "confirm_password": "", "warning": false, "type": "password", "text": "Please fill this in" }
  });

  function resetStates() {
    setSlideCount(0);
    setPasswordEye(false);
    setConfirmPasswordEye(false);
    setCountys();
    readyToSubmit = false;
    setSubmitClicked(false);
    setShowAgreement(true);
    setSubmittedContactId("")
    setPayload({
      first_name: { "first_name": "", "warning": false },
      last_name: { "last_name": "", "warning": false },
      phone: { "phone": "", "warning": false, "text": "Please fill this in" },
      email: { "email": "", "warning": false, "text": "Please fill this in" },
      company: { "company": "", "warning": false },
      tac: { "tac": false, "warning": false },
      checkoutTac: { "checkoutTac": false, "warning": false },
      // category: {"category": "none", "warning": false},
      profession: { "profession": "none", "warning": false },
      are_you_forming_a_new_concierge_community: { "are_you_forming_a_new_concierge_community": "", "warning": false },
      clients_twelve_months: { "clients_twelve_months": "", "warning": false },
      clients_warm_market: { "clients_warm_market": "", "warning": false },
      from_which_profession_receive_most_referrals: { "from_which_profession_receive_most_referrals": "", "warning": false },
      to_which_profession_send_most_referrals: { "to_which_profession_send_most_referrals": "", "warning": false },
      website_url: { "website_url": "", "warning": false },
      instagram_handle: { "instagram_handle": "", "warning": false },
      facebook_link: { "facebook_link": "", "warning": false },
      linkedin_handle: { "linkedin_handle": "", "warning": false },
      tiktok_handle: { "tiktok_handle": "", "warning": false },
      youtube_link: { "youtube_link": "", "warning": false },
      about_yourself: { "about_yourself": "", "warning": false },
      state: { "state": "none", "warning": false },
      county: { "county": "none", "warning": false },
      city: { "city": "", "warning": false },
      zip: { "zip": "", "warning": false },
      preferred_mailing_address: {"preferred_mailing_address": "", "warning": false},
      preferred_mailing_state: {"preferred_mailing_state": "none", "warning": false},
      preferred_mailing_city: {"preferred_mailing_city": "", "warning": false},
      preferred_mailing_zip: {"preferred_mailing_zip": "", "warning": false},
      do_you_consider_real_estate_part_of_your_retirement_strategy: { "do_you_consider_real_estate_part_of_your_retirement_strategy": "", "warning": false },
      // will_you_be_using_the_app_for: {"will_you_be_using_the_app_for": "", "warning": false},
      choose_primary_goal: {
        "choose_primary_goal": [
          "Tax savings",
          "Ease of investment",
          "Cash flow",
          "Capital appreciation",
          "Legacy planning",
          "Home maintenance",
        ], "warning": false
      },
      whats_your_goal_for_capital_appreciation: { "whats_your_goal_for_capital_appreciation": "", "warning": false },
      when_do_you_want_to_achieve_this_capital_appreciation_goal: { "when_do_you_want_to_achieve_this_capital_appreciation_goal": "", "warning": false },
      whats_your_goal_for_cash_flow: { "whats_your_goal_for_cash_flow": "", "warning": false },
      when_do_you_want_to_achieve_this_cash_flow_goal: { "when_do_you_want_to_achieve_this_cash_flow_goal": "", "warning": false },
      // future_growth: {"future_growth": "none", "warning": false},
      introduced_by_name: { "introduced_by_name": "" },
      introduced_by_email: { "introduced_by_email": "", "warning": false, "text": "Enter a valid email" },
      password: { "password": "", "warning": false, "type": "password" },
      confirm_password: { "confirm_password": "", "warning": false, "type": "password", "text": "Please fill this in" }
    });
    setAgreeEnabled(false);
    setreferred(false);
    setReferredImg("");
    setRedeemId();
    setWindowWidth(window.innerWidth);
    setIsPlayClicked(false);
  }

  function handleResize() {
    setWindowWidth(window.innerWidth);
  }

  function resetScroll() {
    if (app.current) app.current.scrollTo({ top: 0, behavior: 'smooth' });
    if (right_container.current) right_container.current.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function inputChangeHandler(property, value) {
    setPayload(prev => {
      let updatedPayload = { ...prev, [property]: { ...prev[property], [property]: value, warning: false } };

      if (property === "preferred_mailing_state") { 
        updatedPayload = { ...updatedPayload, state: { ...prev.state, state: value, warning: false }};
      }else if (property === "preferred_mailing_city") { 
        updatedPayload = { ...updatedPayload, city: { ...prev.city, city: value, warning: false }};
      }else if (property === "preferred_mailing_zip") { 
        updatedPayload = { ...updatedPayload, zip: { ...prev.zip, zip: value, warning: false }};
      }

      return updatedPayload;
    });
  }


  function handleEnter() {
    let timer = setInterval(() => {
      if (document.getElementById(`button${slideCount}`)) {
        window.onkeydown = (e) => e.key === "Enter" ? document.getElementById(`button${slideCount}`).click() : null;
        clearInterval(timer);
      }
    }, 100)
  }

  function formatPhoneNumber(value) {
    let input = value;

    input = input.replace(/\D/g, '');

    input = input.substring(0, 10);

    if (input.length > 6) {
      input = input.replace(/(\d{3})(\d{3})(\d{0,4})/, '($1) $2-$3');
    } else if (input.length > 3) {
      input = input.replace(/(\d{3})(\d{0,3})/, '($1) $2');
    } else if (input.length > 0) {
      input = input.replace(/(\d{0,3})/, '($1');
    }
    return input;
  };

  function passwordEyeHandler() {
    setPayload({ ...payload, "password": { ...payload.password, "type": payload.password.type === "password" ? "text" : "password" } })
    setPasswordEye(!passwordEye);
  }

  function confirmPasswordEyeHandler() {
    setPayload({ ...payload, "confirm_password": { ...payload.confirm_password, "type": payload.confirm_password.type === "password" ? "text" : "password" } })
    setConfirmPasswordEye(!confirmPasswordEye);
  }

  function validateInput(payload, type, property, lengthCheckNum = 0) {

    if (!window.location.href.includes("apply.proinsight") &&
      (property === "clients_warm_market" || property === "from_which_profession_receive_most_referrals" || property === "to_which_profession_send_most_referrals") ||
      (!window.location.href.includes("get.proinsight") && (property === "preferred_mailing_address" ||  property === "preferred_mailing_state" || property === "preferred_mailing_city" || property === "preferred_mailing_zip")) || 
      (!window.location.href.includes("get.proinsight.com")&& !window.location.href.includes("nbp.proinsight.com") && property === "checkoutTac")
    ) {
      return true
    }

    if (window.location.href.includes("nbp.proinsight.com") &&
      (property === "are_you_forming_a_new_concierge_community" || property === "state" || property === "county") || 
       property === "city" || property === "zip" ) {
      return true
    }

    switch (type) {
      case "email":
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(payload[property][property])) {
          payload[property] = { ...payload[property], "warning": false, "text": "Enter a valid email" };
          return true;
        }
        else {
          payload[property] = { ...payload[property], "warning": true, "text": "Invalid email" };
          return false;
        }
      case "checkbox":
        if (payload[property][property]) {
          payload[property] = { ...payload[property], "warning": false };
          return true;
        }
        else {
          payload[property] = { ...payload[property], "warning": true };
          return false;
        }
      case "select":
        if (payload[property][property] !== "none") {
          payload[property] = { ...payload[property], "warning": false };
          return true
        }
        else {
          payload[property] = { ...payload[property], "warning": true };
          return false
        }
      case "number":
        if (payload[property][property] > lengthCheckNum) {
          payload[property] = { ...payload[property], "warning": false };
          return true;
        }
        else {
          payload[property] = { ...payload[property], "warning": true };
          return false;
        }
      case "radio":
        if (payload[property][property]) {
          payload[property] = { ...payload[property], "warning": false };
          return true;
        }
        else {
          payload[property] = { ...payload[property], "warning": true };
          return false;
        }
      default:
        if (payload[property][property] === "" || payload[property][property].length < lengthCheckNum) {
          payload[property] = { ...payload[property], "warning": true };
          return false;
        }
        else {
          payload[property] = { ...payload[property], "warning": false };
          return true;
        }
    }
  }

  const getContactInfo = () => {
    fetch(`https://api.proinsight.com/contacts/${contactId}`)
      .then(resp => resp.json())
      .then(resp => {
        if (resp.contact_id) {
          let temp_payload = { ...payload };
          temp_payload.first_name.first_name = resp.first_name || "";
          temp_payload.last_name.last_name = resp.last_name || "";
          temp_payload.phone.phone = resp.phone || "";
          temp_payload.email.email = resp.email || "";
          temp_payload.company.company = resp.company || "";
          temp_payload.preferred_mailing_address.preferred_mailing_address = resp.preferred_mailing_address || "";
          temp_payload.preferred_mailing_state.preferred_mailing_state = resp.preferred_mailing_state || "";
          temp_payload.preferred_mailing_city.preferred_mailing_city = resp.preferred_mailing_city || "";
          temp_payload.preferred_mailing_zip.preferred_mailing_zip = resp.preferred_mailing_zip || "";

          temp_payload.state.state = resp.preferred_mailing_state || "";
          temp_payload.city.city = resp.preferred_mailing_city || "";
          temp_payload.zip.zip = resp.preferred_mailing_zip || "";
          setPayload({ ...temp_payload });
          // console.log("payload---", payload)
          setSubmittedContactId(resp.contact_id)
        }
      })
      .catch(err => {
        console.log(err);
      })
  }

  useEffect(() => {
    if (!window.location.href.includes("login") && !window.location.href.includes("homeowner-concierge")) {
      const urlParams = new URLSearchParams(window.location.search);
      let invitation = urlParams.get('invitation') || window.location.pathname.replace(/\/$/, '').split('/').pop();

      window.addEventListener('resize', handleResize);

      const hostname = window.location.hostname;
      let isUpdateSlide = true

      if (window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) {
        setShowAgreement(false)
      }

      if (window.location.href.includes("financing.proinsight") || window.location.href.includes("pay.proinsight") || stepIndex == 2) {
        setSlideCount(2)
        isUpdateSlide = false
      } else if (window.location.href.includes("homeowner.proinsight.com")) {
        setShowAgreement(false)
        setSlideCount(13)
        isUpdateSlide = false
      } else if (contactId) {
        setSlideCount(3)
        isUpdateSlide = false
        getContactInfo()
      }

      if (window.location.href.includes("apply.proinsight") && !stepIndex) {
        setSlideCount(0)
        isUpdateSlide = false
      }

      if (invitation?.length > 0) {
        fetch("https://api.proinsight.com/invitation", {
          method: "POST",
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json; charset=UTF-8'
          },
          body: JSON.stringify({ "redeemid": invitation })
        })
          .then(resp => resp.json())
          .then(resp => {
            if (resp.fullname) {
              setReferredImg(resp.invitedbyavataruri);
              setRedeemId(invitation);
              let temp_payload = { ...payload };
              temp_payload.introduced_by_email.introduced_by_email = resp.email || "";
              temp_payload.introduced_by_name.introduced_by_name = resp.fullname;
              setPayload({ ...temp_payload });
              setreferred(true);
              if ((window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && isUpdateSlide) {
                setSlideCount(2);
              } else if (isUpdateSlide) {
                setSlideCount(0);
              }
            }
            else {
              if (window.location.href.includes("get.proinsight.com") && window.location.href.includes("nbp.proinsight.com") && isUpdateSlide) {
                setSlideCount(2);
              } else if (isUpdateSlide) {
                setSlideCount(0);
              }
            }
          })
          .catch(err => {
            console.log(err);
            if ((window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && isUpdateSlide) {
              setSlideCount(2);
            } else if (isUpdateSlide) {
              setSlideCount(0);
            }
          })
      }
      else {
        if ((window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && isUpdateSlide) {
          setSlideCount(2);
        } else if (isUpdateSlide) {
          setSlideCount(0);
        }
      }

      if(!window.location.href.includes("homeowner.proinsight.com")){
        fetch("https://api.proinsight.com/categorydetails", {
          method: "POST",
          headers: {
            'Authorization': token
          }
        })
          .then(resp => resp.json())
          .then(data => setCategories(data))
          .catch(err => {
            alert("Something went wrong while fetching categories");
            console.log(err);
          });

        fetch("https://api.proinsight.com/states", {
          method: "POST",
          headers: {
            'Authorization': token
          }
        })
          .then(resp => resp.json())
          .then(data => setStates(data))
          .catch(err => {
            alert("Something went wrong while states");
            console.log(err);
          });
        }
      return () => {
        window.removeEventListener('resize', handleResize);
      }
    }
  }, [])

  useEffect(() => {
    if (slideCount > 0) handleEnter();
    resetScroll();
  }, [slideCount])

  useEffect(() => {
    // if(payload.category.category === "none"){
    //   setProfessions();
    // }
    // else{
    if (!window.location.href.includes("login") && !window.location.href.includes("homeowner-concierge") && !window.location.href.includes("homeowner.proinsight.com") ) {
      let url = "https://api.proinsight.com/professiondetails"
      if(window.location.href.includes("nbp.proinsight.com")){
        url = "https://api.proinsight.com/nbp_professions"
      }
      fetch(url, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        // body: JSON.stringify({"category_name" : payload.category.category})
      })
        .then(resp => resp.json())
        .then(data => {
          if(window.location.href.includes("nbp.proinsight.com")){
            setProfessions({"Professions": data})
          }else{
            setProfessions(data)
          }
        })
        .catch(err => {
          alert("Something went wrong while fetching professions");
          console.log(err);
        });
      // }
    }

  }, [])

  useEffect(() => {
    if (payload.state.state === "none") {
      setCountys();
    }
    else {
      fetch("https://api.proinsight.com/statetocounties", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({ "state": payload.state.state })
      })
        .then(resp => resp.json())
        .then(data => setCountys(data))
        .catch(err => {
          alert("Something went wrong while fetching countys");
          console.log(err);
        });
    }
  }, [payload.state.state]);

  return (
    <context.Provider
      value={{
        payload,
        setPayload,
        passwordEye,
        setPasswordEye,
        confirmPasswordEye,
        setConfirmPasswordEye,
        inputChangeHandler,
        setSubmitClicked,
        token,
        referred,
        redeemId,
        slideCount,
        setSlideCount,
        urlToRedirect,
        setUrlToRedirect,
        submittedContactId,
        setSubmittedContactId,
        referredImg,
        right_container,
        windowWidth,
        showAgreement,
        setShowAgreement,
        submitClicked,
        categories,
        states,
        professions,
        countys,
        formatPhoneNumber,
        passwordEyeHandler,
        confirmPasswordEyeHandler,
        validateInput,
        agreeEnabled,
        setAgreeEnabled,
        resetStates,
        isPlayClicked,
        setIsPlayClicked
      }}>
      <div className="App" ref={app}>
        <Routes>
          <Route index element={window.location.href.includes("homeowner.proinsight.com") ? <HomeownerLanding /> : <Home readyToSubmit={readyToSubmit} />} />
          <Route path='invite/:inviteId' element={<Home readyToSubmit={readyToSubmit} />} />
          <Route path='invite' element={<Home readyToSubmit={readyToSubmit} />} />
          <Route path=':contactId' element={window.location.href.includes("homeowner.proinsight.com") ? <PropertyOwner /> : <Home readyToSubmit={readyToSubmit} />} />
          <Route path='/login' element={isAuthenticated ? <Navigate to="/homeowner-concierge" replace /> : <AuthPage readyToSubmit={readyToSubmit} />} />
          <Route path='/homeowner-concierge' element={isAuthenticated ? <HomeOwnerConceirge readyToSubmit={readyToSubmit} /> : <Navigate to="/login" replace />} />
          {/* <Route path=':community' element={ <LandingPage /> } /> */}
          <Route path='/community/:contactId' element={ <LandingPage /> } />
        </Routes>
        <ToastContainer />
      </div>
    </context.Provider>
  );
}

export default App;